<ng-container *ngIf="isEnabled && !isActiveMode">
  <vi-program-item
    *ngIf="feature$ | async | ready as feature"
    [program]="feature.feature | modeName: 'program'"
    [hasTemperature]="!!feature?.properties?.temperature?.value"
    [displayProgramTile]="false"
  >
    <app-temperature-select
      item
      *ngIf="feature | executable: 'setTemperature'"
      id="program-mfh-eco-mode-select-{{ feature.feature | modeName }}"
      [title]="feature.feature | modeName | translateOperatingProgram"
      [rangeDefinition]="feature | constraints: 'setTemperature':'targetTemperature'"
      [value]="feature?.properties?.temperature?.value"
      (valueChange)="heatingPanelService.onProgramTemperatureChange($event, feature.feature)"
    ></app-temperature-select>
    <vi-item
      item
      *ngIf="!(feature | executable: 'setTemperature')"
      id="program-mfh-eco-mode-temperature-{{ feature.feature | modeName }}"
      [title]="feature.feature | modeName | translateOperatingProgram"
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [displayProgramTile]="false"
    ></vi-item>
  </vi-program-item>
</ng-container>
